import dynamic from 'next/dynamic';

import { breakpoints } from '@hultafors/shared/constants';

import { ImageBlockFragment } from '@hultafors/hultaforsgroup/types';

const DatoImage = dynamic(
  () => import('@hultafors/shared/components').then((mod) => mod.DatoImage),
  { ssr: false },
);

export const ImageBlock: React.FC<Omit<ImageBlockFragment, 'id'>> = ({
  image,
  fullWidth,
  imageLoad,
}) => {
  const sizes = fullWidth
    ? '100vw'
    : [
        `(min-width: ${breakpoints.maxGridWidth}) 660px`,
        `(min-width: ${breakpoints.mobileMax}) 62.8vw`,
        '100vw',
      ].join(', ');

  const aspectRatio = image?.responsiveImage?.aspectRatio || 16 / 9;

  return imageLoad?.url && image?.responsiveImage ? (
    <div className={fullWidth ? '' : 'content-container'}>
      <DatoImage image={imageLoad} sizes={sizes} aspectRatio={aspectRatio} />
    </div>
  ) : null;
};
